//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { Square } from 'lucide-react';
import { Button } from '../../ui/button';
import { cn } from '../../../lib/utils';

interface StopButtonProps {
  visible: boolean;
  stopping?: boolean;
  onClick: () => void;
}

const StopButton: React.FC<StopButtonProps> = ({
  visible,
  stopping = false,
  onClick,
}) => {
  if (!visible) return null;

  return (
    <Button
      type="button"
      variant="destructive"
      size="icon"
      disabled={stopping}
      onClick={onClick}
      aria-label={stopping ? 'Stopping…' : 'Stop generating'}
      title={stopping ? 'Stopping…' : 'Stop generating'}
      className={cn('shrink-0 rounded-full', stopping && 'opacity-60')}
    >
      <span id="id-ai-module-stop-icon" data-testid="ai-module-stop-icon">
        <Square className="size-3.5 fill-current" />
      </span>
    </Button>
  );
};

export default StopButton;
